"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var o = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "CheckmarkIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M7.75502 14.8036L3.20502 10.4453C2.93166 10.1835 2.93166 9.75898 3.20502 9.49711L4.19494 8.54888C4.4683 8.28702 4.91154 8.28702 5.1849 8.54888L8.25 11.4848L14.8151 5.19638C15.0885 4.93454 15.5317 4.93454 15.8051 5.19638L16.795 6.14461C17.0683 6.40645 17.0683 6.83098 16.795 7.09285L8.74498 14.8036C8.47159 15.0655 8.02838 15.0655 7.75502 14.8036Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
}),
    m = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "CheckmarkIconExtraSmall",
  size: "ExtraSmall",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M5.39644 9.86252L2.14644 6.81174C1.95119 6.62846 1.95119 6.33128 2.14644 6.14798L2.85353 5.48422C3.04879 5.30091 3.36539 5.30091 3.56064 5.48422L5.75 7.53935L10.4394 3.13746C10.6346 2.95418 10.9512 2.95418 11.1465 3.13746L11.8536 3.80123C12.0488 3.98451 12.0488 4.28169 11.8536 4.46499L6.10355 9.86254C5.90828 10.0458 5.5917 10.0458 5.39644 9.86252Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
});

exports.a = o;
exports.b = m;